import {
  HStack,
  Box,
  Text,
} from "@whoosh/design-system/src/components/primitive";

type Props = {
  icon: React.ReactNode;
  label: string;
  value: string;
};

export const InfoLine = ({ icon, label, value }: Props) => {
  return (
    <HStack width="100%" justifyContent="space-between" alignItems="center">
      <HStack alignItems="center" gap={3}>
        <Box
          width={24}
          height={24}
          backgroundColor="surface-main-primary-subtlest"
          borderRadius="2"
          alignItems={"center"}
          justifyContent={"center"}
        >
          {icon}
        </Box>
        <Text>{label}</Text>
      </HStack>
      <Text>{value}</Text>
    </HStack>
  );
};
